import React from 'react';
import './curriculum.css';

const Curriculum = () => {
  return (
    <section id="curriculum" className="curriculum">
      {/* Star elements for the background animation */}
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
    <div className="contenido-seccion">
        <h2>Curriculum</h2>
        <div className="fila">
            <div className="col izquierda">
                <h3>Education</h3>
                <div className="item izq">
                    <h4>Full Stack Python Developer</h4>
                    <span className="casa">Codo a Codo</span>
                    <span className="fecha">Marzo 2024 - Jul 2024</span>
                    <p>Full Stack Programmer career using Python, completing various projects in both Frontend and Backend. Certification in Fullstack Development.</p>
                    <div className="conectori">
                        <div className="circuloi"></div>
                    </div>
                </div>
                <div className="item izq">
                    <h4>Full Stack Developer</h4>
                    <span className="casa">CoderHouse</span>
                    <span className="fecha">Nov 2022 - Apr 2024</span>
                    <p>Full Stack Programmer career using the MERN stack, completing various projects in both Frontend and Backend. Certification in Web Development with HTML and CSS, Certification in JavaScript, Certification in React.js, and Certification in Backend Development.</p>
                    <div className="conectori">
                        <div className="circuloi"></div>
                    </div>
                </div>
                <div className="item izq">
                    <h4>Development: PSEUDOCÓDE</h4>
                    <span className="casa">EGG Academy</span>
                    <span className="fecha">Jul 2022 - Sept 2022</span>
                    <p>Introduction to Programming with Pseudocode - Programming from Scratch (Slack, SCRUM, Algorithms, OOP, Functions, Conditionals, Structures, Arrays).</p>
                    <div className="conectori">
                        <div className="circuloi"></div>
                    </div>
                </div>
                <div className="item izq">
                    <h4>Argentina Programa 1st Edition: #LearnToCode</h4>
                    <span className="casa">Ministerio de Desarrollo Productivo</span>
                    <span className="fecha">Oct 2021 - Dic 2021</span>
                    <p>Introduction to the Basic Fundamentals of Programming - Basic Fundamentals of the JavaScript and Ruby Languages, and Object-Oriented Programming.</p>
                    <div className="conectori">
                        <div className="circuloi"></div>
                    </div>
                </div>
                <div className="item izq">
                    <h4>Bachelor's Degree in Business Administration</h4>
                    <span className="casa">National University of Córdoba</span>
                    <span className="fecha">2008 - 2018</span>
                    <p>Bachelor of Business Administration with a focus on Finance. Execution of investment projects with merit attainment (Brewmasters Project). Surveying and consulting (2x1 Güemes Solidary Project).</p>
                    <div className="conectori">
                        <div className="circuloi"></div>
                    </div>
                </div>
            </div>
            <div className="col derecha">
                <h3>Work experience</h3>
                <div className="item der">
                    <h4>Business Manager</h4>
                    <span className="casa">Lácteos Premium SA</span>
                    <span className="fecha">Sep 2022 - Today</span>
                    <p>Administrative Manager of the company overseeing staff in tasks such as: Finance (Banks, Investments, Cash Flow, Closing, Reports), Accounting (Book Entry, Conciliations, Reports, Taxes), and Administration (Suppliers, Debt collection management, Sales, Indicators).</p>
                    <div className="conectord">
                        <div className="circulod"></div>
                    </div>
                </div>
                <div className="item der">
                    <h4>Business and Financial Manager</h4>
                    <span className="casa">Limbus SAS</span>
                    <span className="fecha">Feb 2020 - Sep 2022</span>
                    <p>Administrative Manager of the company overseeing staff in tasks such as: Finance (Banks, Investments, Cash Flow, Reports), Accounting (Book Entry, Conciliations, Reports, Taxes), and Administration (Suppliers, Debt collection management, Agents, Indicators).</p>
                    <div className="conectord">
                        <div className="circulod"></div>
                    </div>
                </div>
                <div className="item der">
                    <h4>Project Manager</h4>
                    <span className="casa">CIECCA</span>
                    <span className="fecha">Nov 2018 - Nov 2019</span>
                    <p>Project Coordinator for the business chamber, performing tasks such as research, registration, formulation, development, monitoring, and execution of various projects with partner companies of the chamber.</p>
                    <div className="conectord">
                        <div className="circulod"></div>
                    </div>
                </div>
                <div className="item der">
                    <h4>Consulting</h4>
                    <span className="casa">Soluciones Profesionales</span>
                    <span className="fecha">Ago 2016 - Abr 2017</span>
                    <p>Consulting and survey tasks with company clients, financial and administrative advising.</p>
                    <div className="conectord">
                        <div className="circulod"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
)
}

export default Curriculum
